import { render, staticRenderFns } from "./OnboardingDiscoverable.vue?vue&type=template&id=cbc06a8a&scoped=true&"
import script from "./OnboardingDiscoverable.vue?vue&type=script&lang=ts&"
export * from "./OnboardingDiscoverable.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingDiscoverable.vue?vue&type=style&index=0&id=cbc06a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc06a8a",
  null
  
)

export default component.exports